<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()"
  header="{{ headingStatus ? createNewContact : updateNewContact }}">
  <div class="mb-2 left-sidebar clientdetails">
    <form [formGroup]="vendorForm">
      <!-- <h1
        class="mb-3 d-flex justify-content-between align-items-center"
        *ngIf="headingStatus">
        {{ createNewContact }}
      </h1> -->
      <!-- <h1 class="mb-3" *ngIf="!headingStatus">{{ updateNewContact }}</h1> -->
      <div class="row">
        <div>
          <div class="col-12 mb-2">
            <div class="has-float-label">
              <label class="form-label" for="firstname">Name</label>
              <input
                jniAutoCompleteBlocker
                name="firstname"
                type="text"
                pInputText
                class="form-control"
                id="firstname"
                formControlName="name"
                [ngClass]="{ 'has-error': formErrors['name'] }"
                (blur)="logValidationErrors()" />

              <span class="error-msg" *ngIf="formErrors['name']">
                {{ formErrors["name"] }}
              </span>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="has-float-label">
              <label class="form-label" for="phone">phone number</label>
              <input
                jniAutoCompleteBlocker
                name="phone"
                pInputText
                type="text"
                class="form-control"
                id="phone"
                placeholder=""
                formControlName="phoneNumber"
                [ngClass]="{ 'has-error': formErrors['phoneNumber'] }"
                (blur)="logValidationErrors()" />

              <span class="error-msg" *ngIf="formErrors['phoneNumber']">
                {{ formErrors["phoneNumber"] }}
              </span>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="has-float-label">
              <label class="form-label" for="email">Email Address</label>
              <input
                jniAutoCompleteBlocker
                name="email"
                pInputText
                type="text"
                class="form-control"
                id="email"
                placeholder=""
                formControlName="email"
                [ngClass]="{ 'has-error': formErrors['email'] }"
                (blur)="logValidationErrors()" />

              <span class="error-msg" *ngIf="formErrors['email']">
                {{ formErrors["email"] }}
              </span>
            </div>
          </div>
          <div class="col-12 mb-2" [hidden]="true">
            <div class="has-float-label">
              <label class="form-label" for="electronicAddressIdD365"
                >electronicAddressIdD365</label
              >
              <input
                jniAutoCompleteBlocker
                name="electronicAddressIdD365"
                pInputText
                type="text"
                class="form-control"
                id="electronicAddressIdD365"
                placeholder=""
                formControlName="electronicAddressIdD365" />
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="has-float-label">
              <label class="form-label" for="type">Type</label>
              <p-select
                formControlName="type"
                [options]="type"
                optionLabel="name"
                optionValue="name">
              </p-select>
            </div>
          </div>
          <div class="col-12 mb-2">
            <div class="switcher">
              <label class="form-label" for="rcCheck">Primary:</label>
              <div class="d-flex align-items-center form-switch gap-2">
                <p-toggleSwitch
                  name="rcCheck"
                  id="rcCheck"
                  formControlName="isPrimary" />
                <!-- <label class="form-check-label mt-2" for="rcCheck">{{
                this.vendorForm.get("isPrimary")?.value
              }}</label> -->
              </div>
            </div>
          </div>
        </div>
        <div class="mt-5">
          <p-button
            label="Save"
            *ngIf="
              !isFromVendorSummary ||
              (isFromVendorSummary && loggedInUserIsAdmin)
            "
            type="submit"
            [disabled]="!vendorForm.valid"
            (click)="onSubmit()" />
        </div>
      </div>
      <!-- <button
        *ngIf="
          !isFromVendorSummary || (isFromVendorSummary && loggedInUserIsAdmin)
        "
        class="btn btn-primary me-3 post"
        type="submit"
        [disabled]="!vendorForm.valid"
        (click)="onSubmit()">
        
      </button> -->
    </form>
  </div>
</p-drawer>
